export default __webpack_public_path__ + "static/media/no-races.2cf6a1dc.png";